// import { useCallback } from 'react';
// import { Meta } from '../types';
// import { ERROR_MESSAGES, EVENT_TYPES } from '../constants';
// import { createCloneOperation, createDeleteOperation, createVisibilityOperation } from '../operations/';

// interface UseOperationsProps {
//   meta: Meta;
//   selectedPath: string | null;
//   onChange?: (payload: { type: string; data: any }) => void;
//   onSelectedPathChange: (path: string | null) => void;
// }

// export const useOperations = ({
//   meta,
//   selectedPath,
//   onChange,
//   onSelectedPathChange,
// }: UseOperationsProps) => {
//   const handleOperation = useCallback(
//     (type: 'clone' | 'delete' | 'visibility', itemName: string) => {
//       try {
//         if (!selectedPath) {
//           throw new Error(ERROR_MESSAGES.NO_TARGET_PATH);
//         }

//         let operation;
//         switch (type) {
//           case 'clone':
//             operation = createCloneOperation(meta, selectedPath);
//             break;
//           case 'delete':
//             operation = createDeleteOperation(meta, itemName);
//             break;
//           case 'visibility':
//             operation = createVisibilityOperation(meta, itemName);
//             break;
//           default:
//             return;
//         }

//         const newMeta = operation.execute();
//         onChange?.({
//           type: EVENT_TYPES.SET_META,
//           data: newMeta,
//         });

//         // 重置选中状态
//         onSelectedPathChange(null);
//       } catch (error) {
//         console.error(`${type} operation failed:`, error);
//         // TODO: 添加错误提示
//       }
//     },
//     [meta, selectedPath, onChange, onSelectedPathChange]
//   );

//   return {
//     handleOperation,
//   };
// };
import { useCallback } from 'react';
import { FormInstance } from 'antd';
import { Meta, UpdatePayload, OperationContext } from '../types';
import { ERROR_MESSAGES, EVENT_TYPES, OPERATION_TYPES } from '../constants';
import { createOperation } from '../operations/factory';

interface UseOperationsProps {
  meta: Meta;
  selectedPath: string | null;
  onChange?: (payload: UpdatePayload) => void;
  form: FormInstance;
  onSelectedPathChange: (path: string | null) => void;
}

export const useOperations = ({
  meta,
  selectedPath,
  onChange,
  form,
  onSelectedPathChange,
}: UseOperationsProps) => {
  const handleOperation = useCallback(
    (type: keyof typeof OPERATION_TYPES, itemName: string) => {
        console.log('Operation triggered:', {
            type,
            itemName,
            selectedPath,
            metaProps: meta.setters.props.length,
            metaLayout: meta.setters.layout.length
          });
    
      try {
        // 只有克隆操作需要检查选中路径
        if (type === OPERATION_TYPES.CLONE && !selectedPath) {
          throw new Error(ERROR_MESSAGES.NO_TARGET_PATH);
        }

        const context: OperationContext = {
          meta,
          form,
          selectedPath,
          setSelectedPath: onSelectedPathChange,
          onChange: (payload) => {
            console.log('Operation onChange called:', payload);
            onChange?.({
              type: EVENT_TYPES.SET_META,
              data: payload.data,
            });
          },
        };

        const operation = createOperation(type, context);
        console.log('Operation created:', { type, operation });
        operation(itemName);

      } catch (error) {
        console.error(`${type} operation failed:`, error);
        // TODO: 添加错误提示UI
      }
    },
    [meta, selectedPath, onChange, form, onSelectedPathChange]
  );

  return {
    handleOperation,
  };
};